/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelApDivisionLookup.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/ap-division-lookup";

export class AutogenModelApDivisionLookup<RowType extends ModelRow> extends Endpoint<RowType, RowApDivisionLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowApDivisionLookup extends ModelRow<RowApDivisionLookupFields> {
	constructor(values?: Partial<RowApDivisionLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowApDivisionLookupFields {
	ap_glid: string;
	cash_glid: string;
	company_id: string;
	descr: string;
	discount_glid: string;
	expense_glid: string;
	id: string;
	is_active: string;
	voucher_hold: string;
}

